import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useMessages } from "@/context/MessagesContext";
import IslandChat from "@/components/island/IslandChat";
import CallFrame from "@/components/island/CallFrame";
import { Button } from "@/components/ui/button";
import { BellRing, BellOff } from "lucide-react";
import { toast } from "sonner";

export default function Messages() {
  const { incoming, sendEvent } = useMessages();
  const [params] = useSearchParams();
  const [callsEnabled, setCallsEnabled] = useState(false);
  const [call, setCall] = useState(null);
  const [perm, setPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  useEffect(() => { api.get("/island/calls/status").then((r) => setCallsEnabled(r.data.enabled)).catch((e) => console.debug("Calls status check failed", e)); }, []);

  const startCall = async (conv, video) => {
    if (!callsEnabled) { toast.info("Voice & video calls are coming soon — the calling service is not connected yet."); return; }
    try { const { data } = await api.post("/island/calls", { conversation_id: conv?.id || null, video }); setCall(data); } catch (e) { toast.error(errMsg(e)); }
  };
  const enableAlerts = async () => { try { const p = await Notification.requestPermission(); setPerm(p); if (p === "granted") toast.success("Message alerts enabled on this device"); } catch (e) { console.debug("Notification permission failed", e); } };

  return (
    <div data-testid="messages-page">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3">
        <div><p className="label-eyebrow">Private to the Galleon</p><h1 className="mt-1 font-display text-3xl font-700 tracking-tight sm:text-4xl">Messages</h1></div>
        {perm === "default" && <Button variant="outline" size="sm" className="gold-ring" onClick={enableAlerts} data-testid="enable-alerts-btn"><BellRing className="mr-1.5 h-4 w-4 text-[hsl(var(--gold))]" />Enable message alerts</Button>}
        {perm === "granted" && <span className="inline-flex items-center gap-1 text-xs text-emerald-600" data-testid="alerts-enabled"><BellRing className="h-3.5 w-3.5" />Alerts on</span>}
        {perm === "denied" && <span className="inline-flex items-center gap-1 text-xs text-muted-foreground" data-testid="alerts-denied"><BellOff className="h-3.5 w-3.5" />Alerts blocked in browser settings</span>}
      </div>
      <IslandChat frigate={null} incoming={incoming} callsEnabled={callsEnabled} onStartCall={startCall} sendEvent={sendEvent} className="h-[calc(100vh-11.5rem)] min-h-[560px]" initialConversation={params.get("c")} />
      {call && <CallFrame roomUrl={call.room_url} token={call.token} onLeave={() => setCall(null)} />}
    </div>
  );
}
